export default __webpack_public_path__ + "assets/home-two-four.9a194120c80fef65bd4cd8237ab44ee6.png";